<template>
  <div class="system-config">
    <el-tabs type="border-card">
      <el-tab-pane label="积分商城">
        <el-form :model="point" size="medium" label-width="100px" class="setting-form">
          <el-form-item label="支付方式" prop="payment.settingValue">
            <el-select v-model="point.payment.settingValue" placeholder="请选择支付方式">
              <el-option v-for="item in paymentMethod" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="最多使用" prop="maxPoint.settingValue">
            <el-input v-model="point.maxPoint.settingValue" type="number" placeholder="请输入最多使用积分数">
              <el-checkbox slot="prepend" v-model="point.maxPoint.status">启用</el-checkbox>
            </el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="福利商城">
        <el-form :model="welfare" size="medium" label-width="100px" class="setting-form">
          <el-form-item label="支付方式" prop="payment.settingValue">
            <el-select v-model="welfare.payment.settingValue" placeholder="请选择支付方式">
              <el-option v-for="item in paymentMethod" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="热销数量" prop="hotSale.settingValue">
            <el-input v-model="welfare.hotSale.settingValue" type="number" placeholder="请输入热销榜单显示的数量">
              <el-checkbox slot="prepend" v-model="welfare.hotSale.status">显示</el-checkbox>
            </el-input>
          </el-form-item>
          <el-form-item label="上新数量" prop="newSale.settingValue">
            <el-input v-model="welfare.newSale.settingValue" type="number" placeholder="请输入今日上新显示的数量">
              <el-checkbox slot="prepend" v-model="welfare.newSale.status">显示</el-checkbox>
            </el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="优品商城">
        <el-form :model="superior" size="medium" label-width="100px" class="setting-form">
          <el-form-item label="支付方式" prop="payment.settingValue">
            <el-select v-model="superior.payment.settingValue" placeholder="请选择支付方式">
              <el-option v-for="item in paymentMethod" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="热销数量" prop="hotSale.settingValue">
            <el-input v-model="superior.hotSale.settingValue" type="number" placeholder="请输入热销榜单显示的数量">
              <el-checkbox slot="prepend" v-model="superior.hotSale.status">显示</el-checkbox>
            </el-input>
          </el-form-item>
          <el-form-item label="上新数量" prop="newSale.settingValue">
            <el-input v-model="superior.newSale.settingValue" type="number" placeholder="请输入今日上新显示的数量">
              <el-checkbox slot="prepend" v-model="superior.newSale.status">显示</el-checkbox>
            </el-input>
          </el-form-item>
          <el-form-item label="网红专栏" prop="online.settingValue">
            <el-input v-model="superior.online.settingValue" type="number" placeholder="请输入网红专栏显示的数量">
              <el-checkbox slot="prepend" v-model="superior.online.status">显示</el-checkbox>
            </el-input>
          </el-form-item>
          <el-form-item label="换位时间" prop="exchange.settingValue">
            <el-input v-model="superior.exchange.settingValue" type="number" placeholder="请输入左右区交换位置时间，单位（天）" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="全局配置">
        <el-form :model="global" size="medium" label-width="auto" class="setting-form">
          <el-form-item label="是否允许购物" class="global-payment-setting">
            <el-checkbox v-model="global.payment.settingValue.gift">允许购买身份礼包</el-checkbox>
            <el-checkbox v-model="global.payment.settingValue.earnings">允许购买收益礼包</el-checkbox>
            <el-checkbox v-model="global.payment.settingValue.point">允许积分商城购物</el-checkbox>
            <el-checkbox v-model="global.payment.settingValue.welfare">允许福利商城购物</el-checkbox>
            <el-checkbox v-model="global.payment.settingValue.superior">允许优品商城购物</el-checkbox>
          </el-form-item>
          <el-form-item label="审核时显示部分内容">
            <el-checkbox v-model="global.upgrade.settingValue">允许优品商城购物</el-checkbox>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <el-form size="medium" label-width="115px" class="button-form">
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交保存</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      point: {  // 积分商城
        payment: { settingValue: '' },
        maxPoint: { settingValue: '' }
      },
      superior: { // 优品商城
        hotSale: { settingValue: '' },
        newSale: { settingValue: '' },
        online: { settingValue: '' },
        payment: { settingValue: '' },
        exchange: { settingValue: '' }
      },
      welfare: {  // 福利商城
        hotSale: { settingValue: '' },
        newSale: { settingValue: '' },
        payment: { settingValue: '' }
      },
      global: {
        payment: { settingValue: { earnings: true, gift: true, point: true, superior: true, welfare: true }},
        upgrade: { settingValue: 0 }
      },
      paymentMethod: [
        { id: 1, name: '签到积分' },
        { id: 2, name: '补贴积分' },
        { id: 3, name: '转账积分' },
        { id: 4, name: '以上均可' }
      ],
      rules: []
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('./config.scss');
</style>
